var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"content":_vm.content,"effect":"light","placement":"left"}},[_c('font-awesome-icon',{attrs:{"icon":"info-circle"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }